// Events sent from the oauth-backend iframe to the parent window
export var IFrameEventType;
(function (IFrameEventType) {
    IFrameEventType["BrokerageAccountAccessToken"] = "brokerageAccountAccessToken";
    IFrameEventType["Loaded"] = "loaded";
    IFrameEventType["TransferFinished"] = "transferFinished";
    IFrameEventType["OpenOAuthPopup"] = "openOAuthPopup";
    IFrameEventType["Done"] = "done";
    IFrameEventType["Close"] = "close";
    IFrameEventType["IntegrationConnectionError"] = "integrationConnectionError";
    IFrameEventType["IntegrationOAuthStarted"] = "integrationOAuthStarted";
})(IFrameEventType || (IFrameEventType = {}));
// Events sent from the parent window to the caller of the OrbyLink
export var OrbyLinkEventType;
(function (OrbyLinkEventType) {
    OrbyLinkEventType["IntegrationConnected"] = "integrationConnected";
    OrbyLinkEventType["IntegrationConnectionError"] = "integrationConnectionError";
    OrbyLinkEventType["IntegrationOAuthStarted"] = "integrationOAuthStarted";
    OrbyLinkEventType["PageLoaded"] = "pageLoaded";
    OrbyLinkEventType["Done"] = "done";
    OrbyLinkEventType["Close"] = "close";
})(OrbyLinkEventType || (OrbyLinkEventType = {}));
export var OAuthPermissionLevel;
(function (OAuthPermissionLevel) {
    OAuthPermissionLevel["READ"] = "read";
    OAuthPermissionLevel["WRITE"] = "write";
    OAuthPermissionLevel["READ_AND_WRITE"] = "read_and_write";
})(OAuthPermissionLevel || (OAuthPermissionLevel = {}));
export var OrbyLinkOperation;
(function (OrbyLinkOperation) {
    OrbyLinkOperation["LINK_ACCOUNT"] = "link_account";
    OrbyLinkOperation["DEPOSIT"] = "deposit";
    OrbyLinkOperation["PAY_WITH_CRYPTO"] = "pay_with_crypto";
})(OrbyLinkOperation || (OrbyLinkOperation = {}));
const ORBY_EVENT_TYPE_KEYS = [
    OrbyLinkEventType.IntegrationConnected,
    OrbyLinkEventType.IntegrationConnectionError,
    OrbyLinkEventType.IntegrationOAuthStarted,
    OrbyLinkEventType.PageLoaded,
    OrbyLinkEventType.Done,
    OrbyLinkEventType.Close,
];
export function isOrbyEventTypeKey(key) {
    return ORBY_EVENT_TYPE_KEYS.includes(key);
}
